/**
 * Tracking Data Layer — Urbo Theme
 * Utilitários para enviar eventos ao Google Tag Manager / GA4.
 */

(function() {
  'use strict';

  window.urboDataLayer = window.urboDataLayer || {};

  /**
   * Converte centavos do Shopify para valor decimal do GA4.
   */
  function formatCentsToGA4(cents) {
    if (typeof cents !== 'number') return 0;
    return parseFloat((cents / 100).toFixed(2));
  }

  /**
   * Faz push genérico no dataLayer.
   */
  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  /**
   * Envia evento de e-commerce recomendado do GA4.
   */
  function pushEcommerceEvent(eventName, items, options) {
    options = options || {};

    var value = 0;
    (items || []).forEach(function(item) {
      value += (item.price || 0) * (item.quantity || 1);
    });
    value = parseFloat(value.toFixed(2));

    var ecommerce = {
      currency: options.currency || 'BRL',
      value: options.value !== undefined ? options.value : value,
      items: items || []
    };

    if (options.source) {
      ecommerce.source = options.source;
    }
    if (options.coupon) {
      ecommerce.coupon = options.coupon;
    }

    push({
      event: eventName,
      ecommerce: ecommerce
    });
  }

  /**
   * Constrói objeto item GA4 a partir de um produto Shopify.
   */
  function buildItemFromProduct(product, variant) {
    if (!product) return null;

    variant = variant || (product.selected_or_first_available_variant || product.variants[0]);

    var item = {
      item_id: String(product.id),
      item_name: String(product.title || ''),
      item_brand: String(product.vendor || ''),
      currency: 'BRL',
      price: variant && typeof variant.price === 'number' ? formatCentsToGA4(variant.price) : 0,
      quantity: 1
    };

    if (variant && variant.id) {
      item.item_variant_id = String(variant.id);
    }

    if (product.type) {
      item.item_category = String(product.type);
    }

    if (variant && variant.options && variant.options.length > 0) {
      item.item_variant = variant.options.join(' / ');
    } else if (variant && variant.title && variant.title !== 'Default Title') {
      item.item_variant = variant.title;
    }

    return item;
  }

  /**
   * Constrói objeto item GA4 a partir de um item do carrinho Shopify.
   */
  function buildItemFromCartItem(cartItem) {
    if (!cartItem) return null;

    var item = {
      item_id: String(cartItem.product_id || cartItem.id),
      item_name: String(cartItem.product_title || cartItem.title || ''),
      item_brand: String(cartItem.vendor || ''),
      currency: 'BRL',
      price: typeof cartItem.price === 'number' ? formatCentsToGA4(cartItem.price) : 0,
      quantity: cartItem.quantity || 1
    };

    if (cartItem.variant_id) {
      item.item_variant_id = String(cartItem.variant_id);
    }

    if (cartItem.variant_title && cartItem.variant_title !== 'Default Title') {
      item.item_variant = cartItem.variant_title;
    } else if (cartItem.options_with_values && cartItem.options_with_values.length > 0) {
      var opts = [];
      cartItem.options_with_values.forEach(function(opt) {
        opts.push(opt.value);
      });
      item.item_variant = opts.join(' / ');
    }

    return item;
  }

  /**
   * Envia evento customizado (não de e-commerce).
   */
  function pushCustomEvent(eventName, data) {
    var payload = { event: eventName };
    if (data && typeof data === 'object') {
      Object.keys(data).forEach(function(key) {
        payload[key] = data[key];
      });
    }
    push(payload);
  }

  // API pública
  window.urboDataLayer = {
    push: push,
    pushEcommerceEvent: pushEcommerceEvent,
    pushCustomEvent: pushCustomEvent,
    buildItemFromProduct: buildItemFromProduct,
    buildItemFromCartItem: buildItemFromCartItem,
    formatCentsToGA4: formatCentsToGA4
  };
})();
